// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GlkJ","label":"styles_label__19X1G"};